function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { PublicChannelContext } from '../layouts/PublicChannelLayout';
import { createSongRequest, deleteSongRequest, getPlaylist, getSongRequestQueue } from '@/actions/SongRequestActions';
import SongRequests from '../song_requests/SongRequestTable';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { FormattedMessage, useIntl } from 'react-intl';
import InputModal from '../InputModal';
import { Box, Button, ButtonGroup, useDisclosure } from '@chakra-ui/react';
import { useParams } from 'react-router';
import SongRequestRow from '../song_requests/SongRow';
import Table from '../Table';
import useQueryState from '@/hooks/useQueryState';
import { PlaylistSortType, SongTableType } from '@/types/client';
import PlaylistTable from '../song_requests/PlaylistTable';
import { useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import CaptchaModal from '../CaptchaModal';
import { HTTPError } from '@/utils/api';
import { useDebouncedCallback } from 'use-debounce';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { Table as MantineTable } from '@mantine/core';
import TableHeading from '../TableHeading';
function CurrentPlayingTable(param) {
    var currentSong = param.currentSong;
    return /*#__PURE__*/ _jsx(Table, {
        data: currentSong == null ? [] : [
            currentSong
        ],
        renderHeader: function() {
            return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                children: [
                    /*#__PURE__*/ _jsx(TableHeading, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "1vUhCw",
                            defaultMessage: "Now Playing"
                        })
                    }),
                    /*#__PURE__*/ _jsx(TableHeading, {
                        alignRight: true,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "dDzs68",
                            defaultMessage: "Requested By"
                        })
                    })
                ]
            });
        },
        renderEmptyState: function() {
            return /*#__PURE__*/ _jsx(Box, {
                display: "grid",
                placeItems: "center",
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "LcMvLr",
                    defaultMessage: "No song is currently playing"
                })
            });
        },
        renderRow: function(song) {
            return /*#__PURE__*/ _jsx(SongRequestRow, {
                song: song
            });
        }
    });
}
export default function SongRequestsPublic() {
    var _useContext = useContext(PublicChannelContext), publicChannel = _useContext.channel;
    var currentUser = useAuthenticationStore(function(store) {
        return store.user;
    });
    var username = useParams().username;
    var _React_useState = _sliced_to_array(React.useState(null), 2), currentSong = _React_useState[0], setCurrentSong = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), songRequests = _React_useState1[0], setSongRequests = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), pendingSongRequest = _React_useState2[0], setPendingSongRequest = _React_useState2[1];
    var _useQueryState = _sliced_to_array(useQueryState('table', {
        defaultValue: SongTableType.QUEUE
    }), 2), songRequestQueueType = _useQueryState[0], setSongRequestQueueType = _useQueryState[1];
    var _React_useState3 = _sliced_to_array(React.useState(null), 2), selectedSongRequest = _React_useState3[0], setSelectedSongRequest = _React_useState3[1];
    var deleteSongRequestModal = useDisclosure();
    var requestSongModal = useDisclosure();
    var captchaModal = useDisclosure();
    var intl = useIntl();
    var _React_useState4 = _sliced_to_array(React.useState(false), 2), isSearching = _React_useState4[0], setIsSearching = _React_useState4[1];
    var _React_useState5 = _sliced_to_array(React.useState(null), 2), playlist = _React_useState5[0], setPlaylist = _React_useState5[1];
    var _React_useState6 = _sliced_to_array(React.useState(PlaylistSortType.CREATED_AT), 2), playlistSortType = _React_useState6[0], setPlaylistSortType = _React_useState6[1];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), playlistSortDirection = _useSortDirectionQueryState[0], setPlaylistSortDirection = _useSortDirectionQueryState[1];
    var _React_useState7 = _sliced_to_array(React.useState(true), 2), playlistHasMore = _React_useState7[0], setPlaylistHasMore = _React_useState7[1];
    var _React_useState8 = _sliced_to_array(React.useState(0), 2), playlistTotal = _React_useState8[0], setPlaylistTotal = _React_useState8[1];
    var _React_useState9 = _sliced_to_array(React.useState(Date.now()), 2), playlistRandomSeed = _React_useState9[0], setPlaylistRandomSeed = _React_useState9[1];
    var _React_useState10 = _sliced_to_array(React.useState(''), 2), playlistSearch = _React_useState10[0], setPlaylistSearch = _React_useState10[1];
    var _React_useState11 = _sliced_to_array(React.useState(10), 2), playlistLimit = _React_useState11[0], setPlaylistLimit = _React_useState11[1];
    var _React_useState12 = _sliced_to_array(React.useState(0), 2), playlistPage = _React_useState12[0], setPlaylistPage = _React_useState12[1];
    var playlistLoadingRef = React.useRef(false);
    var loadPlaylist = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var _param_search, search, _param_sortBy, sortBy, _param_sortDirection, sortDirection, _param_seed, seed, _param_limit, limit, _param_page, page, reset, _ref, newPlaylist, newOffset, total;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_search = param.search, search = _param_search === void 0 ? playlistSearch : _param_search, _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? playlistSortType : _param_sortBy, _param_sortDirection = param.sortDirection, sortDirection = _param_sortDirection === void 0 ? playlistSortDirection : _param_sortDirection, _param_seed = param.seed, seed = _param_seed === void 0 ? playlistRandomSeed : _param_seed, _param_limit = param.limit, limit = _param_limit === void 0 ? playlistLimit : _param_limit, _param_page = param.page, page = _param_page === void 0 ? playlistPage : _param_page;
                        if (publicChannel == null || playlistLoadingRef.current) {
                            return [
                                2
                            ];
                        }
                        reset = playlistRandomSeed !== seed;
                        if (!reset && !playlistHasMore) {
                            return [
                                2
                            ];
                        }
                        playlistLoadingRef.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            getPlaylist(publicChannel._id, {
                                limit: limit,
                                offset: page * limit,
                                sort_by: sortBy !== null && sortBy !== void 0 ? sortBy : undefined,
                                q: search !== null && search !== void 0 ? search : undefined,
                                direction: sortDirection !== null && sortDirection !== void 0 ? sortDirection : undefined,
                                seed: seed
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), newPlaylist = _ref.playlist, newOffset = _ref.offset, total = _ref.total;
                        setPlaylistTotal(total);
                        setPlaylist(function(prev) {
                            return reset ? newPlaylist : _to_consumable_array(prev !== null && prev !== void 0 ? prev : []).concat(_to_consumable_array(newPlaylist));
                        });
                        setPlaylistHasMore(total > newOffset + newPlaylist.length);
                        setPlaylistSortDirection(sortDirection);
                        setPlaylistSortType(sortBy);
                        setPlaylistRandomSeed(seed);
                        setPlaylistSearch(search);
                        setPlaylistLimit(limit);
                        setPlaylistPage(page);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        playlistLoadingRef.current = false;
                        setIsSearching(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        playlistSearch,
        playlistSortType,
        playlistSortDirection,
        playlistRandomSeed,
        playlistLimit,
        playlistPage,
        publicChannel,
        playlistHasMore,
        setPlaylistSortDirection,
        setPlaylistSortType,
        setPlaylistSearch,
        setPlaylistLimit,
        setPlaylistPage
    ]);
    React.useEffect(function() {
        if (publicChannel == null) {
            return;
        }
        getSongRequestQueue(publicChannel._id).then(function(param) {
            var queue = param.queue, current = param.current;
            setSongRequests(queue);
            setCurrentSong(current);
        }).catch(console.error);
        loadPlaylist({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        publicChannel
    ]);
    var debouncedSearch = useDebouncedCallback(function(search) {
        loadPlaylist({
            search: search,
            page: 0,
            seed: Date.now()
        });
    }, 1000);
    var addSongRequest = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(url, token) {
            var songRequest, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (url == null || publicChannel == null || songRequests == null) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            createSongRequest(publicChannel._id, url, token)
                        ];
                    case 2:
                        songRequest = _state.sent();
                        setSongRequests(_to_consumable_array(songRequests).concat([
                            songRequest
                        ]));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (_instanceof(error, HTTPError) && error.statusCode === 429) {
                            setPendingSongRequest(url);
                            captchaModal.onOpen();
                            return [
                                2
                            ];
                        }
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(url, token) {
            return _ref.apply(this, arguments);
        };
    }(), [
        captchaModal,
        publicChannel,
        songRequests
    ]);
    var removeSongRequest = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (publicChannel == null || selectedSongRequest == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteSongRequest(publicChannel._id, selectedSongRequest._id)
                    ];
                case 1:
                    _state.sent();
                    setSongRequests(function(prev) {
                        var _prev_filter;
                        return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(song) {
                            return song._id !== selectedSongRequest._id;
                        })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        publicChannel,
        selectedSongRequest,
        setSongRequests
    ]);
    var handleSongRequestDelete = React.useCallback(function(song) {
        setSelectedSongRequest(song);
        deleteSongRequestModal.onOpen();
    }, [
        deleteSongRequestModal
    ]);
    var tableToggleButtonGroup = /*#__PURE__*/ _jsxs(ButtonGroup, {
        isAttached: true,
        size: "sm",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                onClick: function() {
                    return setSongRequestQueueType(SongTableType.QUEUE);
                },
                variant: songRequestQueueType === SongTableType.QUEUE ? 'cta' : 'outline',
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "4YDNPC",
                    defaultMessage: "Queue"
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: function() {
                    return setSongRequestQueueType(SongTableType.PLAYLIST);
                },
                variant: songRequestQueueType === SongTableType.PLAYLIST ? 'cta' : 'outline',
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "bv2dU7",
                    defaultMessage: "Playlist"
                })
            })
        ]
    });
    var _publicChannel_displayName;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "d06KmF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "A list of requested songs"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "Srnzyy",
                    defaultMessage: "{channelName}'s Song Requests",
                    values: {
                        channelName: (_publicChannel_displayName = publicChannel === null || publicChannel === void 0 ? void 0 : publicChannel.displayName) !== null && _publicChannel_displayName !== void 0 ? _publicChannel_displayName : username
                    }
                })
            }),
            /*#__PURE__*/ _jsx(CurrentPlayingTable, {
                currentSong: currentSong
            }),
            songRequestQueueType === SongTableType.QUEUE ? /*#__PURE__*/ _jsx(SongRequests, {
                songRequests: songRequests,
                onAddSongRequest: requestSongModal.onOpen,
                beforeControlsElement: tableToggleButtonGroup,
                onSongRequestDelete: handleSongRequestDelete,
                onCheckCanDeleteSongRequest: function(song) {
                    return currentUser != null && song != null && song.user.provider === currentUser.provider && song.user.providerId === currentUser.providerId;
                }
            }) : null,
            songRequestQueueType === SongTableType.PLAYLIST ? /*#__PURE__*/ _jsx(PlaylistTable, {
                playlist: playlist !== null && playlist !== void 0 ? playlist : [],
                total: playlistTotal,
                page: playlistPage,
                limit: playlistLimit,
                sortType: playlistSortType,
                sortDirection: playlistSortDirection,
                setSort: function(type, direction) {
                    return loadPlaylist({
                        page: 0,
                        sortBy: direction == null ? null : type,
                        sortDirection: direction,
                        seed: Date.now()
                    });
                },
                isSearching: isSearching,
                search: playlistSearch,
                onSearch: function(search) {
                    setIsSearching(true);
                    setPlaylistSearch(search);
                    debouncedSearch(search);
                },
                onLimit: function(limit) {
                    return loadPlaylist({
                        limit: limit,
                        page: 0,
                        seed: Date.now()
                    });
                },
                onNextPage: function() {
                    return loadPlaylist({
                        page: playlistPage + 1,
                        seed: Date.now()
                    });
                },
                onPreviousPage: function() {
                    return loadPlaylist({
                        page: playlistPage - 1,
                        seed: Date.now()
                    });
                },
                beforeControlsElement: tableToggleButtonGroup
            }) : null,
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deleteSongRequestModal.isOpen,
                onClose: deleteSongRequestModal.onClose,
                onSubmit: removeSongRequest,
                title: intl.formatMessage({
                    id: "bk1sVO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Song Request"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "+EVqwV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this song request?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "K3r6DQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "LkAaU6",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Request a Song"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "y0/Win",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the song you want to request"
                        }
                    ]
                }),
                isOpen: requestSongModal.isOpen,
                onClose: requestSongModal.onClose,
                submitText: intl.formatMessage({
                    id: "AcTvIK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Request Song"
                        }
                    ]
                }),
                onSubmit: addSongRequest,
                input: {
                    placeholder: intl.formatMessage({
                        id: "b6C1lG",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Song name or URL"
                            }
                        ]
                    })
                }
            }),
            /*#__PURE__*/ _jsx(CaptchaModal, {
                title: intl.formatMessage({
                    id: "x0NtHj",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Captcha Required"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "pWjXBT",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please complete the captcha to request a song"
                        }
                    ]
                }),
                isOpen: captchaModal.isOpen,
                onClose: captchaModal.onClose,
                confirmText: intl.formatMessage({
                    id: "AcTvIK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Request Song"
                        }
                    ]
                }),
                onConfirm: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(token) {
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        addSongRequest(pendingSongRequest, token)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    });
                    return function(token) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        ]
    });
}
